<ng-template #customRow let-row>
  <div class="expanded-row-container layout-auto-1-auto">
    <div>
      <exg-input [(ngModel)]="row.tbNameClone"
                 caption="Name"
                 name="tbName"
                 type="text">
      </exg-input>
      <exg-input [(ngModel)]="row.tbTextShortClone"
                 caption="{{getResource('ShortTextDesc')}}"
                 name="tbTextShort"
                 type="text">
      </exg-input>
    </div>
    <div style="min-width: 0; overflow: hidden">
      <editor *ngIf="MCEinit"
              class="content app-border-none-tiny"
              [(ngModel)]="row.tbTextClone"
              [init]="MCEinit">
      </editor>
    </div>
    <div class="spawn-reverse">
      <button
        (click)="editorDelete(row)"
        class="md-btn">
        {{getGlobal('Delete')}}
      </button>
      <button
        (click)="editorSave(row)"
        class="md-btn">
        {{getGlobal('Save')}}
      </button>
    </div>
  </div>
</ng-template>

<div class="content md3-surface">
  <div class="content md3-card-on-surface"
       style="display:flex; flex-direction:column; overflow-y:auto; overflow-x:hidden">
    <exg-search-bar (Search)="TBList.search($event)"
                    placeholder="{{getResource('LookUp')}}"
                    class="span-layout">
      <ng-template #rightTemplate>
        <i (click)="loadTBData()" class="search-action fal fa-sync"></i>
        <i (click)="startCreate()" class="search-action fal fa-plus"></i>
      </ng-template>
    </exg-search-bar>

    <ng-container *ngIf="form.visible">
      <div #newFormContainer style="padding: 1rem">
        <h6 style="margin-bottom: 1rem">{{getResource('AddNew')}}</h6>
        <form #tvForm="ngForm">
          <exg-input
            name="tbName"
            caption="Name"
            [maxlength]="256"
            [(ngModel)]="form.row.tbName"
            [required]="true">
          </exg-input>
          <exg-input
            name="tbTextShort"
            caption="{{getResource('ShortText')}}"
            [maxlength]="1024"
            [(ngModel)]="form.row.tbTextShort">
          </exg-input>
          <div style="padding-top: 0.5rem">
            <editor *ngIf="MCEinit"
                    class="content app-border-none-tiny"
                    name="tbText"
                    [(ngModel)]="form.row.tbText"
                    [init]="MCEinit">
            </editor>
          </div>
          <div class="spawn-reverse">
            <button class="md-btn"
                    type="button"
                    (click)="form.visible = false">
              {{getGlobal('Cancel')}}
            </button>
            <button class="md-btn"
                    type="button"
                    [disabled]="tvForm.invalid || saving"
                    (click)="save(tvForm)">
              <i *ngIf="saving" class="far fa-spin fa-spinner"></i>
              {{getGlobal('Save')}}
            </button>
          </div>
        </form>
      </div>
    </ng-container>

    <exg-table #VCTBList
               selectKey="tbID"
               [metaInfo]="TBList.MetaInfo"
               [displayState]="TBList.state"
               [rowSource]="TBList.data"
               [tableDef]="TBList.tableDefinition"
               [allowSingleSelection]="true"
               [allowMultiSelection]="false"
               [selectSource]="TBList.selectedRow"
               [allowRowExpansion]="true"
               [expandedArray]="[]"
               [expandedTemplate]="customRow"
               (FilterActivation)="loadTBData()"
               (RowChange)="TBList.selectionChanged($event)"
               style="flex: 1; min-height: 0">
    </exg-table>

    <exg-pager (PageChange)="TBList.pageChanged($event)"
               [pagingSource]="TBList.paging"
               class="span-layout">
    </exg-pager>
  </div>
</div>
